import { html } from 'lit';
import { PlayCircle } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-play-circle')
export class PdsIconPlayCircle extends PdsIcon {
  @state()
  icon = PlayCircle;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
